import TitleElement from './TitleElement';
import TitleElementDefinition from './TitleElementDefinition';
import TitleElementMetaData from './TitleElementMetaData';

export default {
  TitleElement: TitleElement,
  TitleElementDefinition: TitleElementDefinition,
  TitleElementType: TitleElementMetaData.type
};
